import { render, staticRenderFns } from "./MentionBox.vue?vue&type=template&id=c189c4fa&scoped=true&"
import script from "./MentionBox.vue?vue&type=script&lang=js&"
export * from "./MentionBox.vue?vue&type=script&lang=js&"
import style0 from "./MentionBox.vue?vue&type=style&index=0&id=c189c4fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c189c4fa",
  null
  
)

export default component.exports